import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useMemo } from 'react';
import { ProductImageSizesPortraitEnum, } from '@as-react/common-types';
import { Carousel, CarouselVariant, Image, TextSize, Text, TextAlign, I18N_NAMESPACES, Overlay, Group, GroupGutter, GroupVerticalAlign, } from '@as/cotopaxi';
import { getPortraitImageSizeUrlByProductCode } from '../../../util/ImageUtil';
import { useTranslation } from 'react-i18next';
import LabelsOverlay from '../../common/labels-overlay/LabelsOverlay';
const LABELS_AMOUNT = 1;
const FIRST_IMAGE = 0;
export const MiniPDPImageCarousel = ({ images, productCode, productImageCdnDomains, isOutOfStock, hasAnotherAvailableColor, genderFeatureId, showGenderIcon, savingsPercentage, priceOverlay, showNewProductLabel, showOnlineExclusiveLabel, showSustainabilityLabel, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const isMobile = useMediaQueryMatchesOnMobile();
    const imageCarouselConfig = {
        overlay: isOutOfStock && (_jsx(Text, { emphasized: true, align: TextAlign.CENTER, size: isMobile ? TextSize.SMALL : TextSize.LARGE, children: hasAnotherAvailableColor ? t('wishlist.outOfStock.other.color.available') : t('product.temporarilyOutOfStock') })),
        variant: CarouselVariant.MINI_PDP_IMAGE,
        showPagination: false,
        configurationOverrides: {
            rebuildOnUpdate: true,
            preventClicks: true,
            slidesPerView: 'auto',
            watchOverflow: true,
            spaceBetween: 12,
            shouldSwiperUpdate: true,
            allowSlideNext: !isOutOfStock,
            allowSlidePrev: !isOutOfStock,
            allowTouchMove: !isOutOfStock,
        },
    };
    return useMemo(() => (_jsx(Carousel, Object.assign({}, imageCarouselConfig, { children: images.map((image, index) => {
            const imageUrl = getPortraitImageSizeUrlByProductCode(productCode, image.picture, productImageCdnDomains, ProductImageSizesPortraitEnum.basket);
            return (_jsxs("div", { className: "a:relative", children: [_jsx(Image, { src: imageUrl }), index === FIRST_IMAGE && (_jsx(Overlay, { noPointerEvents: true, stretchContent: true, children: _jsx(Group, { gutter: GroupGutter.NONE, valign: GroupVerticalAlign.BOTTOM, children: _jsx(Box, { paddingBlockEnd: "1", children: _jsx(LabelsOverlay, { maxLabels: LABELS_AMOUNT, showGenderIcon: showGenderIcon, genderFeatureId: genderFeatureId, savingsPercentage: savingsPercentage, priceOverlay: priceOverlay, showNewProductLabel: showNewProductLabel, showOnlineExclusiveLabel: showOnlineExclusiveLabel, showSustainabilityLabel: showSustainabilityLabel, dataQA: "mini_pdp_product_image_overlay" }) }) }) }))] }, imageUrl));
        }) }))), [isOutOfStock, images]);
};
